export * as attachments from '@wix/auto_sdk_crm_attachments/schemas';
export * as contacts from '@wix/auto_sdk_crm_contacts/schemas';
export * as extendedFields from '@wix/auto_sdk_crm_extended-fields/schemas';
export * as labels from '@wix/auto_sdk_crm_labels/schemas';
export * as submittedContact from '@wix/auto_sdk_crm_submitted-contact/schemas';
export * as notes from '@wix/auto_sdk_crm_notes/schemas';
export * as cards from '@wix/auto_sdk_crm_cards/schemas';
export * as pipelines from '@wix/auto_sdk_crm_pipelines/schemas';
export * as tasks from '@wix/auto_sdk_crm_tasks/schemas';
